<template>
  <div id="data-list-list-view" v-if="items" class="data-list-container">
    <vs-prompt
      v-if="editRegion"
      :title="editRegion.id ? 'Update region' : 'Add new region'"
      @cancel="val = ''"
      @accept="acceptAddRolePrompt"
      @close="closeAddRolePrompt"
      :active.sync="addRegionPrompt"
    >
      <div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-5/5 w-full">
            <vs-input
              label="Enter unique region number"
              v-on:keypress="isAllowedInput($event)"
              v-model="editRegion.number"
              class="mt-5 w-full"
              name="item-name"
            />
            <vs-input
              label="Enter region name"
              v-model="editRegion.name"
              class="mt-5 w-full"
              name="item-name"
            />
            <vs-select class="mt-5 w-full" label="Select region country" v-model="editRegion.country">
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in countryOptions"
              />
            </vs-select>
          </div>
        </div>
      </div>
    </vs-prompt>
    <h3>Region</h3>

    <vs-table
      ref="table"
      class="mt-8"
      v-model="selected"
      pagination
      :max-items="itemsPerPage"
      search
      :data="items"
      @selected="onClicked(selected)"
    >
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <!-- ADD NEW -->
          <div
            @click="addNewRegion"
            class="
              btn-add-new
              p-3
              mb-4
              mr-4
              rounded-lg
              cursor-pointer
              flex
              items-center
              justify-center
              text-lg
              font-medium
              text-base text-primary
              border border-solid border-primary
            "
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Add region</span>
          </div>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div
            class="
              p-4
              border border-solid
              d-theme-border-grey-light
              rounded-full
              d-theme-dark-bg
              cursor-pointer
              flex
              items-center
              justify-between
              font-medium
            "
          >
            <span class="mr-2"
              >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{ items.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : items.length }}
              of {{ queriedItems }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 40">
              <span>40</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 100">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="number">Number</vs-th>
        <vs-th sort-key="title">Name</vs-th>
        <vs-th sort-key="country">Country</vs-th>
        <vs-th>Actions</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.number }}
              </p>
            </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.name }}
              </p>
            </vs-td>
            <vs-td>
              <vs-chip color="primary" class="product-order-status">{{ tr.countryName }}</vs-chip>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="confirmDelete(tr.id)"
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      newRegionNumber: "",
      newRegionName: "",
      newRegionCountry: "dk",
      roleToDelete: null,
      editRegion: null,

      countryOptions: [
        { text: "Denmark", value: "dk" },
        { text: "Norway", value: "no" },
        { text: "Finland", value: "fi" },
        { text: "United Kingdom", value: "uk" },
      ],

      addRegionPrompt: false,
      query: "*",

      items: [],
      selected: [],
      itemsPerPage: 100,
      isMounted: false,
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },

    queriedItems() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.items.length;
    },
  },
  methods: {
    updateStartDate: function (date) {
      console.log("Update Start Date:", date);
      this.localStartDate = date;

      console.log(this.localStartDate);

      this.constrainDates();
    },
    updateEndDate: function (date) {
      console.log("Update End Date:", date);
      this.localEndDate = date;

      console.log(this.localEndDate);

      this.constrainDates();
    },
    isAllowedInput(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[0-9]+$/.test(char)) return true;
      else e.preventDefault();
    },
    getItems: function () {
      this.$vs.loading();

      this.$http
        .get(process.env.VUE_APP_API + "/Idam/Region") // query?
        .then(resp => {
          console.log("Regions:", resp.data);
          this.items = resp.data;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    addNewRegion() {
      this.editRegion = {
        number: "",
        name: "",
        country: "dk",
      };
      this.addRegionPrompt = true;
    },

    onClicked(region) {
      this.editRegion = region;
      this.addRegionPrompt = true;
    },

    addNewData() {},

    confirmDelete(roleId) {
      this.roleToDelete = roleId;

      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to remove this region?",
        accept: this.deleteRole,
      });
    },
    deleteRole() {
      const url = process.env.VUE_APP_API + "/Idam/Region/" + this.roleToDelete;

      this.$http
        .delete(url)
        .then((/*resp*/) => {
          this.$vs.notify({
            color: "success",
            title: "Success",
            text: "Region deleted",
          });

          this.getItems();
        })
        .catch(err => {
          console.log(err);

          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Could not delete Region: " + err,
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    editData(data) {
      console.log("Edit:", data);
    },
    getNumModulesColor(numModules) {
      if (numModules == 0) return "warning";
      return "success";
    },
    getStatusColor(status) {
      if (status === true) return "success";
      return "danger";
    },
    acceptAddRolePrompt() {
      this.$vs.loading();

      const url = process.env.VUE_APP_API + "/Idam/Region";

      const payload = this.editRegion;

      const method = payload.id == null ? this.$http.post(url, payload) : this.$http.put(url, payload);
      method
        .then(() => {
          this.$vs.notify({
            color: "success",
            title: "Success",
            text: "Region added",
          });

          this.editRegion = null;
          this.getItems();
        })
        .catch(err => {
          console.log(err);

          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Could not add region: " + err,
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    closeAddRolePrompt() {},
  },
  created() {
    this.getItems();
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>

<style lang="scss">
.status-category {
  display: flex;
  align-items: center;
}

.status-circle {
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  margin-right: 5px;
}

#data-list-list-view {
  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>